import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// Base API URL from environment variables
const apiUrl = process.env.REACT_APP_API_URL;

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

// Thunk: Fetch categories based on type
export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (categoryType, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/GetCategories/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        params: { category_type: categoryType },
      });
      return response.data; // Return the fetched categories
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch categories");
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        // toast.success("Categories fetched successfully!"); // Updated message
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "An error occurred";
        // toast.error(state.error);
      });
  },
});

export default categoriesSlice.reducer;
